exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.item-count[data-v-dc11fdc2]{position:absolute;top:1rem;right:1rem;padding:.5rem 1rem;z-index:9;background:white;color:#444\n}\n.item-count .icon[data-v-dc11fdc2]{display:inline-block;padding:0 1rem 0 0\n}\n", ""]);




//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dc11fdc2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"includePaths":["/home/runner/work/parks-rec-finder/parks-rec-finder/node_modules/foundation-sites/scss"]}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/home/runner/work/parks-rec-finder/parks-rec-finder/src/style/_variables.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ItemCount.vue
// module id = 684
// module chunks = 0